import * as angular from 'angular';

angular.module('app').filter('shareToken', shareToken);

function shareToken(uriUtility) {
	return function (url, token) {
		return url && uriUtility.fromPattern(url, { share: token });
	};
}
